<template>
    <div class="home">
        <Head-view :userName="'CZ0000001'"></Head-view>
        <div class="main">
            <div class="initializationPage">
                <div class="banner">
                    <div class="initFont">
                        <div class="helloUser">
                            Hello,{{ date.staffName }}
                        </div>
                        <div class="nowTime">
                            今天是{{ date.nowTime }}，欢迎回到<span>{{ date.insUser }}智慧巡检系统</span>
                        </div>
                        <div class="nowTime">
                            上次登陆时间：{{ date.landOldTime }}
                        </div>
                        <div class="nowTime">
                            系统到期时间： {{ date.termTime }}
                        </div>
                    </div>
                </div>
                <div class="bottomBack">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { getTime } from "@/untils/tools";
import HeadView from "@/components/HeadView";

export default {
    name: "Home",
    components: {
        HeadView,
    },
    data() {
        return {
            date: {
                staffName: '',
                insUser: '',
                nowTime: '',
                landOldTime: '',
                termTime: ''
            }
        };
    },

    created() {},

    mounted() {
        this.date.nowTime = getTime(1)
        let userData = JSON.parse(localStorage.getItem("userData"))
        this.date.landOldTime = userData.lastTime
        this.date.termTime = (userData.insExpireTime) ? userData.insExpireTime : '永久有效'
        this.date.insUser = userData.insName
        this.date.staffName = userData.staffName
    },
    methods: {
      

        getStatisticsInit() {
            let data = {
                token: this.getCookie()
            }
            this.request.post(this.baseUrl + 'institution/getStatistics', data).then(res => {
                console.log(res)
            })
        }
    },
};
</script>

<style lang="less" scoped>
.home {
    width: 100%;
    height: 100vh;
    
    .main {
        padding: 80px 0 0 234px;

        .initializationPage {
            margin-right: 24px;

            .banner {
                width: 100%;
                height: 651px;
                background: url("../../assets/home/home.png") no-repeat 0 0;
                background-size: 100% 100%;
            }

            .bottomBack {
                width: 100%;
                height: 200px;
                background-color: #fff;
            }

            .icoSum {
                margin-top: 26px;
                display: flex;
                flex-direction: row;
                width: 100%;
                .dataBox {
                    width: 16.6%;
                    height: 119px;
                    background: rgba(255, 255, 255, 1);
                    border-radius: 8px;
                }
            }
        }
    }
}

.initFont {
    padding: 32px 0 0 36px;

    .helloUser {
        height: 53px;
        color: rgba(128, 128, 128, 1);
        font-size: 36px;
        font-weight: 700;
    }

    .nowTime {
        padding-top: 10px;
        left: 270px;
        top: 180px;
        height: 30px;
        font-size: 19px;
        font-weight: 500;
        color: rgba(128, 128, 128, 1);
        span {
            color: rgba(25, 137, 250, 1);
        }
    }
}

.marginLeft {
    margin-left: 17px;
}
</style>
